import CloseIcon from '@mui/icons-material/Close';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import React from 'react';

import ProjectSections from './ProjectSections';

const Project = ({
  project,
  handleActiveProject,
  navigate,
  searchParameters,
}: {
  project: Project;
  handleActiveProject: HandleActiveProject;
  navigate: Navigate;
  searchParameters: URLSearchParams;
}) => {
  const providerColors = new Set(['aws', 'azure', 'gcp']);
  const setProviderColor = (inputProvider: string) => {
    const provider = inputProvider.toLowerCase();
    return providerColors.has(provider) ? provider : '';
  };

  return (
    <div className="project">
      <Modal
        open={true}
        disableAutoFocus={true}
        onClose={() => handleActiveProject('', navigate, searchParameters)}
      >
        <Fade in={true}>
          <Box className="project-container">
            <Button
              classes={{ root: 'project-close' }}
              onClick={() =>
                handleActiveProject('', navigate, searchParameters)
              }
            >
              <CloseIcon />
            </Button>
            <div className="intro">
              <span className="title">{project.title}</span>
              <span className="description">{project.description}</span>
            </div>
            {project.providers && project.providers.length > 0 && (
              <div className="providers">
                <span>Cloud Service Provider(s):</span>
                <Stack direction="row" spacing={1}>
                  {project.providers
                    .toSorted((a, b) => a.localeCompare(b))
                    .map((provider) => (
                      <Chip
                        classes={{
                          root: `providers-tag ${setProviderColor(provider)}`,
                        }}
                        key={provider}
                        label={provider}
                      />
                    ))}
                </Stack>
              </div>
            )}
            <div className="tags-list">
              <Stack direction="row" spacing={1}>
                {project.tags
                  .toSorted((a, b) => a.localeCompare(b))
                  .map((tag) => {
                    if (!project.providers.includes(tag)) {
                      return (
                        <Chip
                          classes={{
                            root: 'tags-list-tag',
                            label: 'tags-list-tag-label',
                          }}
                          key={tag}
                          label={tag}
                        />
                      );
                    }
                  })}
              </Stack>
            </div>
            <ProjectSections project={project} />
            <div className="learn-more">
              <a
                href="https://duplocloud.com/request-a-demo/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Request a Demo to Learn More{' '}
                <TipsAndUpdatesIcon className="learn-more-icon" />
              </a>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default Project;
